
<RouterView v-if="allowed" />
